module.exports = __webpack_public_path__ + "media/components/assets/images/cold_web-5b431e183b8dbf038fbd78c289090dd4.png";